import {LangKeyType} from '../../../../provider/locale/translation/type';
import {MainFilterFieldNameEnum} from '../../../../service/main-filter/main-filter-type';

export const headerFilterDrawerWidth = 512;

export const mainFilterFieldPlaceholderKeyMap: Record<MainFilterFieldNameEnum, LangKeyType> = {
    [MainFilterFieldNameEnum.BRANDS]: 'MAIN_FILTER__BRAND__PLACEHOLDER',
    [MainFilterFieldNameEnum.CITIES]: 'MAIN_FILTER__CITY__PLACEHOLDER',
    [MainFilterFieldNameEnum.CODES]: 'MAIN_FILTER__COMPANY_CODE__PLACEHOLDER',
    [MainFilterFieldNameEnum.COUNTRIES]: 'MAIN_FILTER__COUNTRY__PLACEHOLDER',
    [MainFilterFieldNameEnum.GROUPS]: 'MAIN_FILTER__GROUP__PLACEHOLDER',
    [MainFilterFieldNameEnum.GROUPS_LOGICAL_OPERATION]: 'MAIN_FILTER__GROUP_OPERATIONS__LABEL',
    [MainFilterFieldNameEnum.NAMES]: 'MAIN_FILTER__COMPANY_NAME__PLACEHOLDER',
    [MainFilterFieldNameEnum.REGIONS]: 'MAIN_FILTER__REGION__PLACEHOLDER',
    [MainFilterFieldNameEnum.STREETS]: 'MAIN_FILTER__STREET__PLACEHOLDER',
    [MainFilterFieldNameEnum.CLOSED]: 'MAIN_FILTER__OPEN_CLOSE__PLACEHOLDER',
    [MainFilterFieldNameEnum.ACTIVE]: 'MAIN_FILTER__OPEN_CLOSE__PLACEHOLDER',
    [MainFilterFieldNameEnum.IS_PRIORITY_PLACEMENT]: 'MAIN_FILTER__PRIORITY_PLACEMENT__LABEL',
    [MainFilterFieldNameEnum.IS_PAID]: 'MAIN_FILTER__IS_PAID__PLACEHOLDER',
    [MainFilterFieldNameEnum.NEED_MODERATE]: 'MAIN_FILTER__NEED_MODERATE__PLACEHOLDER',
};

export const mainFilterFieldLabelKeyMap: Record<MainFilterFieldNameEnum, LangKeyType> = {
    [MainFilterFieldNameEnum.BRANDS]: 'MAIN_FILTER__BRAND__LABEL',
    [MainFilterFieldNameEnum.CITIES]: 'MAIN_FILTER__CITY__LABEL',
    [MainFilterFieldNameEnum.CODES]: 'MAIN_FILTER__COMPANY_CODE__LABEL',
    [MainFilterFieldNameEnum.COUNTRIES]: 'MAIN_FILTER__COUNTRY__LABEL',
    [MainFilterFieldNameEnum.GROUPS]: 'MAIN_FILTER__GROUP__LABEL',
    [MainFilterFieldNameEnum.GROUPS_LOGICAL_OPERATION]: 'MAIN_FILTER__GROUP_OPERATIONS__LABEL',
    [MainFilterFieldNameEnum.NAMES]: 'MAIN_FILTER__COMPANY_NAME__LABEL',
    [MainFilterFieldNameEnum.REGIONS]: 'MAIN_FILTER__REGION__LABEL',
    [MainFilterFieldNameEnum.STREETS]: 'MAIN_FILTER__STREET__LABEL',
    [MainFilterFieldNameEnum.CLOSED]: 'MAIN_FILTER__OPEN_CLOSE__LABEL',
    [MainFilterFieldNameEnum.ACTIVE]: 'MAIN_FILTER__ACTIVE__LABEL',
    [MainFilterFieldNameEnum.IS_PRIORITY_PLACEMENT]: 'MAIN_FILTER__PRIORITY_PLACEMENT_OPTION',
    [MainFilterFieldNameEnum.IS_PAID]: 'MAIN_FILTER__IS_PAID__LABEL',
    [MainFilterFieldNameEnum.NEED_MODERATE]: 'MAIN_FILTER__NEED_MODERATE__LABEL',
};

export const fieldToRenderNames: Array<MainFilterFieldNameEnum> = [
    MainFilterFieldNameEnum.GROUPS,
    MainFilterFieldNameEnum.GROUPS_LOGICAL_OPERATION,
    MainFilterFieldNameEnum.BRANDS,
    MainFilterFieldNameEnum.COUNTRIES,
    MainFilterFieldNameEnum.REGIONS,
    MainFilterFieldNameEnum.CITIES,
    MainFilterFieldNameEnum.STREETS,
    MainFilterFieldNameEnum.NAMES,
    MainFilterFieldNameEnum.CODES,
    MainFilterFieldNameEnum.CLOSED,
    MainFilterFieldNameEnum.ACTIVE,
    MainFilterFieldNameEnum.IS_PRIORITY_PLACEMENT,
    MainFilterFieldNameEnum.IS_PAID,
    MainFilterFieldNameEnum.NEED_MODERATE,
];
